module.exports = __webpack_public_path__ + "static/logo-kk4d@2x-a982e9ddde766729ad4fef3c88c23c11.png";